/* Designix — confort mobile (fichier mis en cache, 07/10/2026) */

/* Carrousels mobiles (04/10) : barre de progression, fondu retire en fin de piste, petit glissement d'amorce
   la premiere fois que le carrousel entre a l'ecran. Rien ne s'execute au-dessus de 749 px. */
(function(){
  if (!window.matchMedia || !matchMedia('(max-width: 749px)').matches) return;
  var calme = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function brancher(el){
    if (el.__dxCaro) return; el.__dxCaro = 1;
    var prog = document.createElement('div'); prog.className = 'dx-caro-prog'; prog.setAttribute('aria-hidden','true');
    var pouce = document.createElement('i'); prog.appendChild(pouce); el.parentNode.insertBefore(prog, el.nextSibling);
    function maj(){
      var max = el.scrollWidth - el.clientWidth;
      if (max < 8 || !el.clientWidth) { prog.style.display = 'none'; el.classList.add('dx-fin'); return; }
      prog.style.display = ''; var r = el.clientWidth / el.scrollWidth, w = Math.max(14, 72 * r);
      pouce.style.width = w + 'px'; pouce.style.transform = 'translateX(' + ((72 - w) * Math.min(1, el.scrollLeft / max)) + 'px)';
      el.classList.toggle('dx-fin', el.scrollLeft >= max - 6);
    }
    el.addEventListener('scroll', function(){ requestAnimationFrame(maj); }, { passive: true });
    addEventListener('resize', maj); maj(); setTimeout(maj, 800);
    if (!calme && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(es){ es.forEach(function(e){
        if (!e.isIntersecting) return; io.disconnect();
        if (el.scrollLeft > 0 || el.scrollWidth - el.clientWidth < 40) return;
        setTimeout(function(){ el.scrollTo({ left: 56, behavior: 'smooth' });
          setTimeout(function(){ el.scrollTo({ left: 0, behavior: 'smooth' }); }, 650); }, 350);
      }); }, { threshold: 0.7 });
      io.observe(el);
    }
    return maj;
  }
  function tout(){ document.querySelectorAll('.dxf-pieces, .dxf-panel, .dxh-colcaro, .dxh-toprow').forEach(function(el){ var m = brancher(el); }); 
    document.querySelectorAll('.dxf-panel').forEach(function(el){ el.dispatchEvent(new Event('scroll')); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  /* changement de piece : le panneau actif change de largeur, on recalcule */
  document.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('.dxf-pieces')) setTimeout(tout, 60); });
})();

;

/* Navigation mobile (04/10) — corrections relevees par les tests de navigation. */
(function(){
  /* 1. Menu : toucher le NOM d'une categorie qui a un sous-menu ouvre ce sous-menu (comme la fleche),
        au lieu d'envoyer sur une page fourre-tout. « Tout voir » reste dans le sous-menu. */
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('.dxa__cat-link'); if (!a) return;
    var fl = a.parentElement && a.parentElement.querySelector('.dxa__cat-arrow'); if (!fl) return;
    e.preventDefault(); fl.click();
  }, true);
  /* Meme logique au niveau 2 : le nom ouvre le niveau 3 quand il existe (« Tout voir » reste dans le niveau 3) */
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('.dxa__sub-link'); if (!a || a.tagName !== 'A') return;
    var fl = a.parentElement && a.parentElement.querySelector('.dxa__sub-arrow'); if (!fl) return;
    e.preventDefault(); fl.click();
  }, true);
  /* 2. Collections et recherche : apres un filtre, un tri ou un changement de page, on arrive sur les produits,
        pas en haut de page (sauf retour arriere, ou le navigateur remet la position). */
  function versProduits(){
    if (!/template-(collection|search)/.test(document.body.className)) return;
    if (!/[?&](filter\.|sort_by=|page=)/.test(location.search)) return;
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward') return;
    var cible = document.querySelector('.dxcol__filterbar') || document.querySelector('.dxcol__grid');
    if (!cible) return;
    var y = cible.getBoundingClientRect().top + scrollY - 8;
    if (y > 200) scrollTo(0, y);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', versProduits); else versProduits();
  /* 3. Panneau de recherche : le champ garde le focus (clavier ouvert) meme si l'animation d'ouverture le lui retire */
  document.addEventListener('click', function(e){
    if (!(e.target.closest && e.target.closest('[data-search-open], .dx-head__searchbar'))) return;
    setTimeout(function(){ var i = document.querySelector('.dsx-search__input'); if (i && document.activeElement !== i) i.focus({ preventScroll: true }); }, 80);
  }, true);
})();

;

/* Achats en quantite (04/10) : total de chaque ligne du panier, et rappel du compte pro (-30 %) a partir de 5 pieces. */
(function(){
  var L = (document.documentElement.lang || 'fr').slice(0, 2);
  var T = { fr: 'Vous en prenez plusieurs ? Avec un compte pro, −30 % dès le premier article et un devis avec date ferme. ',
            en: 'Buying several? With a trade account, 30% off from the first item and a quote with a firm date. ',
            de: 'Mehrere Stück? Mit einem Firmenkonto 30 % Rabatt ab dem ersten Artikel und ein Angebot mit festem Termin. ' }[L] || '';
  var A = { fr: 'Ouvrir un compte pro', en: 'Open a trade account', de: 'Firmenkonto eröffnen' }[L];
  if (!T) return;
  function F(c){ try { return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: 'EUR' }).format(c / 100); } catch (e) { return (c / 100).toFixed(2) + ' €'; } }
  function hint(cls){ var p = document.createElement('p'); p.className = 'dx-pro-hint ' + cls; p.appendChild(document.createTextNode(T));
    var a = document.createElement('a'); a.href = '/pages/compte-pro#compte-pro'; a.textContent = A; p.appendChild(a); return p; }
  /* Fiche produit : a partir de 5 pieces */
  function fiche(){ var q = document.getElementById('dx-qty'), row = document.querySelector('.dx-buyrow'); if (!q || !row) return;
    var h = document.querySelector('.dx-pro-hint--fiche'), n = parseInt(q.value, 10) || 1;
    if (n >= 5 && !h) row.parentNode.insertBefore(hint('dx-pro-hint--fiche'), row.nextSibling); else if (n < 5 && h) h.remove(); }
  document.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('.dx-qty')) setTimeout(fiche, 30); });
  document.addEventListener('input', function(e){ if (e.target.id === 'dx-qty') fiche(); });
  /* Panier : total par ligne + rappel pro */
  var sig = '';
  function panier(){ if (!document.querySelector('[data-key]')) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function(r){ return r.json(); }).then(function(c){
      var s = c.items.map(function(i){ return i.key + ':' + i.quantity + ':' + i.final_line_price; }).join('|') + document.querySelectorAll('[data-key]').length;
      if (s === sig && document.querySelector('.dx-ligne-total, .dx-pro-hint--panier') ) return; sig = s;
      var k = {}; c.items.forEach(function(i){ k[i.key] = i; });
      document.querySelectorAll('[data-key]').forEach(function(row){ var it = k[row.getAttribute('data-key')], col = row.querySelector('.cart__item-price-col'); if (!it || !col) return;
        var el = col.querySelector('.dx-ligne-total'); if (it.quantity < 2) { if (el) el.remove(); return; }
        if (!el) { el = document.createElement('small'); el.className = 'dx-ligne-total'; col.appendChild(el); }
        el.textContent = it.quantity + ' × ' + F(it.final_price) + ' = ' + F(it.final_line_price); });
      var ship = document.querySelector('.dxcp__ship'), h = document.querySelector('.dx-pro-hint--panier');
      if (ship && c.item_count >= 5 && !h) ship.parentNode.insertBefore(hint('dx-pro-hint--panier'), ship.nextSibling);
      else if (h && c.item_count < 5) h.remove();
    }).catch(function(){});
  }
  var tm; new MutationObserver(function(ms){
    for (var i = 0; i < ms.length; i++) { var t = ms[i].target; if (t.closest && t.closest('.dx-ligne-total, .dx-pro-hint')) continue;
      clearTimeout(tm); tm = setTimeout(panier, 450); return; } }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ panier(); fiche(); }); else { panier(); fiche(); }
})();

;

/* Filtres appliques sans rechargement (04/10) : la grille se met a jour en AJAX et l'adresse change ;
   on ramene alors la vue sur les produits (avant : la page restait en haut, 2 produits visibles). */
(function(){
  function demarrer(){
  if (!/template-(collection|search)/.test(document.body.className)) return;
  function versGrille(){
    if (!/[?&](filter\.|sort_by=|page=)/.test(location.search)) return;
    var c = document.querySelector('.dxcol__filterbar') || document.querySelector('.dxcol__grid'); if (!c) return;
    var y = c.getBoundingClientRect().top + scrollY - 8; if (y > 200 && scrollY < y - 40) scrollTo({ top: y, behavior: 'smooth' });
  }
  ['pushState', 'replaceState'].forEach(function(m){ var o = history[m]; history[m] = function(){ var r = o.apply(this, arguments); setTimeout(versGrille, 450); return r; }; });
  document.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('.dxcol__filters-apply, [data-dxcol-filter-close]')) setTimeout(versGrille, 450); });
  }
  if (document.body) demarrer(); else document.addEventListener('DOMContentLoaded', demarrer);
})();

;

/* Coeur pose (04/10) : message « Ajoute a votre liste · Voir », pour que le visiteur sache ou retrouver sa liste. */
(function(){
  var L = (document.documentElement.lang || 'fr').slice(0, 2);
  var T = { fr: ['Ajouté à votre liste', 'Voir'], en: ['Added to your list', 'View'], de: ['Zu Ihrer Liste hinzugefügt', 'Ansehen'] }[L] || ['Ajouté à votre liste', 'Voir'];
  var t, el;
  document.addEventListener('click', function(e){
    var h = e.target.closest && e.target.closest('.dw-heart'); if (!h) return;
    setTimeout(function(){
      if (!h.classList.contains('is-on')) return;
      if (!el) { el = document.createElement('div'); el.className = 'dx-wish-toast'; el.setAttribute('role', 'status');
        el.innerHTML = '<span></span><a href="/pages/wishlist"></a>'; document.body.appendChild(el); }
      el.firstChild.textContent = T[0]; el.lastChild.textContent = T[1];
      el.classList.add('is-on'); clearTimeout(t); t = setTimeout(function(){ el.classList.remove('is-on'); }, 2600);
    }, 60);
  });
})();

;

/* Croix de fermeture dans chaque sous-menu (niveaux 2 et 3) : copie de la croix principale (meme attribut, meme action). */
(function(){
  function go(){ var x = document.querySelector('.dxa__close'); if (!x) return;
    document.querySelectorAll('.dxa__sub-head').forEach(function(h){ if (h.querySelector('.dx-sub-close')) return;
      var c = x.cloneNode(true); c.classList.add('dx-sub-close'); h.appendChild(c); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
